export default __webpack_public_path__ + "static/media/avatar-richard.ace8e089.png";